import { RouteType } from "types/RouteType";
import RootStore from "../../../stores/RootStore";

const panelPlantTrackerRoute: RouteType = {
  name: "Panel Plant Tracker",
  path: "/panel-plant-tracker",
  layout: "/app",
  group: "Production",
  hidden: true,
  requiresAuth: true,
  requiresPermission: false,
  channels: ["panel-plant", "production", "qc", "schedule"],
  component: () =>
    import("./PanelPlantTracker.Container").then((m) => ({
      default: m.PanelPlantTrackerContainer,
    })),
  beforeEnter: async ({ rootStore }) => {
    const panelStore = rootStore.panelStore;
    if (panelStore && typeof panelStore === "object" && "find" in panelStore) {
      await (panelStore as any).find();
    }

    // Load related data for context
    const scheduleStore = rootStore.schedulingDayStore;
    if (
      scheduleStore &&
      typeof scheduleStore === "object" &&
      "find" in scheduleStore
    ) {
      await (scheduleStore as any).find();
    }

    return true;
  },
  onParamsChange: async ({ rootStore, params, previousParams }) => {
    if (
      params.jobId !== previousParams?.jobId ||
      params.status !== previousParams?.status
    ) {
      const panelStore = rootStore.panelStore;
      if (
        panelStore &&
        typeof panelStore === "object" &&
        "find" in panelStore
      ) {
        const query: any = {};
        if (params.jobId) query.jobId = params.jobId;
        if (params.status) query.status = params.status;
        await (panelStore as any).find(query);
      }
    }
  },
  dialogs: [
    {
      name: "updatePanelStatus",
      component: () =>
        import("./PanelStatusUpdate").then((m) => ({
          default: m.PanelStatusUpdate,
        })),
      title: "Update Panel Status",
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const panelPlantFormStore = rootStore.panelPlantFormStore;
        if (
          panelPlantFormStore &&
          typeof panelPlantFormStore === "object" &&
          "save" in panelPlantFormStore
        ) {
          await (panelPlantFormStore as any).save();
          return true;
        }
        return false;
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const panelPlantFormStore = rootStore.panelPlantFormStore;
        return panelPlantFormStore &&
          typeof panelPlantFormStore === "object" &&
          "isValid" in panelPlantFormStore
          ? (panelPlantFormStore as any).isValid
          : false;
      },
    },
    {
      name: "recordQC",
      component: () =>
        import("./QCRecordForm").then((m) => ({ default: m.QCRecordForm })),
      title: "Record Quality Control",
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const qcFormStore = rootStore.qcFormStore;
        if (
          qcFormStore &&
          typeof qcFormStore === "object" &&
          "save" in qcFormStore
        ) {
          await (qcFormStore as any).save();
          return true;
        }
        return false;
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const qcFormStore = rootStore.qcFormStore;
        return qcFormStore &&
          typeof qcFormStore === "object" &&
          "isValid" in qcFormStore
          ? (qcFormStore as any).isValid
          : false;
      },
    },
  ],
};

export default panelPlantTrackerRoute;
